export const findLocalityDetails = async (
    LocalitiesService: woosmap.map.LocalitiesService,
    publicId: string,
    locale: string,
) => {
    const detailsResponse = await LocalitiesService.getDetails({
        publicId: publicId,
        language: locale,
    });

    return detailsResponse.result;
};
